import axios from 'axios';
const BACKEND_URL = process.env.REACT_APP_API_URL;  

const API_BASE_URL = `${BACKEND_URL}/hotel-owner`;
const API_AGENT_URL=`${BACKEND_URL}/api/agents`;

// Helper function for GET requests
async function getJSON(url, token) {
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
}

//  Get hotel owner details
export async function getHotelOwnerDetails(ownerId, token) {
  return getJSON(`${API_BASE_URL}/owner/${ownerId}`, token);
}

// Get all hotels for a specific owner
export async function getHotelsByOwner(ownerId, token) {
  return getJSON(`${API_BASE_URL}/owner/${ownerId}/hotels`, token);
}

// Get all listings for a specific owner
export async function getListingsByOwner(ownerId, token) {
  return getJSON(`${API_BASE_URL}/owner/${ownerId}/listings`, token);
}

// Get bookings for a specific owner
export async function getBookingsByOwner(ownerId, token) {
  return getJSON(`${API_BASE_URL}/owner/${ownerId}/bookings`, token);
}

// Get total payouts for a specific owner
export async function getTotalPayout(ownerId, token) {
  return getJSON(`${API_BASE_URL}/owner/${ownerId}/total-payout`, token);
}

// Get last payout for a specific owner
export async function getLastPayout(ownerId, token) {
  return getJSON(`${API_BASE_URL}/owner/${ownerId}/last-payout`, token);
}

// Get all reviews for a specific owner's listings
export async function getReviewsByOwner(ownerId, token) {
  return getJSON(`${API_BASE_URL}/owner/${ownerId}/reviews`, token);
}

export const getAgentMonthlyEarnings = (travelerAgentId, token) =>
  getJSON(`${API_AGENT_URL}/earnings/${travelerAgentId}`, token);

export async function getBookingsByAgentOwner(ownerId, travelerDetailsId, token) {
  return getJSON(`${API_BASE_URL}/owner/${ownerId}/${travelerDetailsId}/bookings`, token);
}

export const cancelBookingByOwner = async (ownerId, bookingId, token) => {
  const response = await axios.patch(
    `${API_BASE_URL}/owner/${ownerId}/booking/${bookingId}/cancel`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};